// Store
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useDownloadPhotosStore } from "@/stores/downloadPhotos/downloadPhotos";
import { useEvaluationResultStore } from "@/stores/evaluationResult/evaluationResult";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useOperatorExecutingStore } from "@/stores/operatorExecuting/operatorExecuting";
import { useSuccessfulEvaluationStore } from "@/stores/successfulEvaluation/successfulEvaluation";
import { useBuyDeviceStore } from "~/tiw/stores/buyDevice/buyDevice";
import { useDeliveryStore } from "~/tiw/stores/delivery/delivery";
import { useTIWStore } from "~/tiw/stores/tiw/tiw";
import { useVerificationStore } from "~/tiw/stores/verification/verification";

/** Сбросить STORE Приложения */
export default function useStoreResetter(): void {
    const BuyDeviceStore = useBuyDeviceStore();
    const ChooseDeviceStore = useChooseDeviceStore();
    const HowYouRateDeviceStore = useHowYouRateDeviceStore();
    const DownloadPhotosStore = useDownloadPhotosStore();
    const OperatorExecutingStore = useOperatorExecutingStore();
    const SuccessfulEvaluationStore = useSuccessfulEvaluationStore();
    const EvaluationResultStore = useEvaluationResultStore();
    const DeliveryStore = useDeliveryStore();
    const VerificationStore = useVerificationStore();
    const TIWStore = useTIWStore();

    TIWStore.restoreToDefault();
    BuyDeviceStore.restoreToDefault();
    ChooseDeviceStore.restoreToDefault();
    HowYouRateDeviceStore.restoreToDefault();
    DownloadPhotosStore.restoreToDefault();
    OperatorExecutingStore.restoreToDefault();
    SuccessfulEvaluationStore.restoreToDefault();
    EvaluationResultStore.restoreToDefault();
    DeliveryStore.restoreToDefault();
    VerificationStore.restoreToDefault();
}
